<template>
  <div>
    <!-- Hero Section -->
    <Hero
      :image-src="require('@/assets/slide-market-car.png')"
      :headingText="heroContent.headingText"
      :paragraphText="heroContent.paragraphText"
      :buttonLink="heroContent.buttonLink"
      :buttonVariant="heroContent.buttonVariant"
      :buttonText="heroContent.buttonText"
    />

    <!-- Flip and Hold Section -->
    <div
      class="grid grid-cols-1 lg:grid-cols-2 container lg:max-w-7xl gap-10 lg:my-16"
    >
      <div class="border-2 p-4 flex flex-row justify-between gap-5 items-center">
        <img src="../assets/flip.png" class="w-[140px] h-[140px]" />
        <div>
          <Heading variant="h2">Flip Cars like the Pros</Heading>
          <p>
            Flip Cars like the pros from the palm of your hand in $100 shares
            for 90days or less and share the financial results with the seller
          </p>
          <Button to="/flip" variant="primary" tag="router-link"
            >Get Started</Button
          >
        </div>
      </div>
      <div class="border-2 p-4 flex flex-row justify-between gap-5 items-center">
        <img src="../assets/hold.png" class="w-[140px] h-[140px]" />
        <div>
          <Heading variant="h2">HOLD ownership shares</Heading>
          <p>
            HOLD ownership shares of the finest collector cars and diversify
            your collection with shared custody in a true democratic ownership
            platform
          </p>
          <Button to="/hold" variant="primary" tag="router-link"
            >Get Started</Button
          >
        </div>
      </div>
    </div>

    <!-- Blockqoute Section -->
    <BlockQuoteImage
      imageName="homepage-2.png"
      quote="CONGRATS on the 1998 Targa flip!  Excellent news for us investors!  All went so smoothly that I want to re-invest in the 1961 Corvette Fuelie"
      author="Larry Jacobs"
    />

    <!-- Flip Assets Section -->
    <div class="container lg:max-w-7xl my-8">
      <Heading variant="h2" class="my-2">Featured Investment Vehicles</Heading>
      <div if="flipAssetList" class="grid grid-cols-2 lg:grid-cols-4 gap-10">
        <div v-for="(asset, a) in flipAssetList.entries" :key="a">
          <CarCard :asset="asset"></CarCard>
        </div>
      </div>
    </div>

    <!-- Blockqoute Section -->
    <BlockQuoteImage
      imageName="hero02.jpg"
      quote="Exceptional and a seamless experience becoming a shareowner with BlueChipCar.com!"
      author="Antonio Brunet"
    />
    <!-- News Section -->
    <!-- <div class="container lg:max-w-7xl my-8">
    <Heading variant="h2" class="my-2">Latest Investment News</Heading>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <NewsCard
        v-for="(item, index) in cardItems"
        :key="index"
        :link="item.link"
        :image-src="require('@/assets/' + item.imageSrc)"
        :title="item.title"
        :description="item.description"
      />
    </div>
    </div> -->
  </div>
</template>

<script>
import Heading from "./Heading";
import Button from "./Button";
import CarCard from "./CarCard";
import BlockQuoteImage from "./BlockQuoteImage";
import { mapGetters, mapActions } from "vuex";
import Hero from "./Hero.vue";


export default {
  name: "HomePage",
  components: {
    Heading,
    Button,
    CarCard,
    BlockQuoteImage,
    Hero,
  },
  computed: {
    ...mapGetters(["flipAssetList"]),
  },

  data: () => ({
    // List query we'll pass to the state action.
    listQuery: {
      sort: null,
      offset: "0",
      pageSize: "4",
      promoted: true,
      salesModel: "all",
    },
    heroContent: {
      headingText: "Welcome to BlueChipCar.com - <br /> Your Trusted Fractional Marketplace of the Finest Collector Cars!",
      paragraphText:
        "BlueChipCar is dedicated to revolutionizing car enthusiasts’ involvement in the collector car ownership experience.  BlueChipCar Fractional Marketplace is designed with you in mind, offering convenience, reliability, and a commitment to delivering an unparalleled experience linking like-minded car enthusiasts and the rarest and finest collector cars.",
      buttonLink: "https://dev-bcc.us.auth0.com/login",
      buttonVariant: "secondary",
      buttonText: "Open an account",
    },

    cardItems: [
      {
        link: "https://example.com/1",
        imageSrc: "slide-market-car.png",
        title: "Card Title 1",
        description: "Description for card 1.",
      },
      {
        link: "https://example.com/2",
        imageSrc: "slide-market-car.png",
        title: "Card Title 2",
        description: "Description for card 2.",
      },
      {
        link: "https://example.com/3",
        imageSrc: "slide-market-car.png",
        title: "Card Title 3",
        description: "Description for card 3.",
      },
    ],
  }),

  methods: {
    ...mapActions(["getFlipAssets"]),
  },

  created() {
    this.getFlipAssets(this.listQuery);
  },
};
</script>
